// Adapted from https://github.com/codegenixdev/react-hook-form-mui-zod-boilerplate
// and YT video https://www.youtube.com/watch?v=JyeWoqWsQFo
import { TextField, TextFieldProps } from '@mui/material'
import errorShake from '@utils/animations'
import { Controller, FieldValues, Path, useFormContext } from 'react-hook-form'

type Props<T extends FieldValues> = {
	name: Path<T>
	helperText?: string
} & TextFieldProps

export default function RHFTextField<T extends FieldValues>({
	name,
	required = false,
	label,
	...rest
}: Props<T>) {
	const { control } = useFormContext()

	return (
		<Controller
			name={name}
			control={control}
			render={({ field: { ref, value, ...field }, fieldState: { error } }) => {
				const helper = error?.message ? error.message : rest.helperText
				return (
					<TextField
						sx={{
							'@keyframes shake': errorShake,
							animation: error ? 'shake 0.25s' : null,
						}}
						autoComplete="noAutocomplete"
						{...field}
						value={value || ''}
						inputRef={ref}
						{...rest}
						error={!!error}
						helperText={helper}
						label={required ? `${label} *` : label}
					/>
				)
			}}
		/>
	)
}
